import script from "./AllActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./AllActions.vue?vue&type=script&setup=true&lang=ts"

import "./AllActions.vue?vue&type=style&index=0&id=717e2f6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-717e2f6e"]])

export default __exports__